import 'mapbox-gl/dist/mapbox-gl.css';

import Image, { getImageProps } from 'next/image';

import AppFooter from '../components/AppFooter';
import AppNav from '../components/AppNav';
import Link from 'next/link';
import PhoneIcon from '../components/PhoneIcon';
import headerBg from '../public/assets/header-bg.png';
import laundryBg from '../public/assets/laundry-bg.png';
import laundryBgSmall from '../public/assets/laundry-bg-small.png';
import mapboxgl from 'mapbox-gl';
import photo2 from '../public/assets/foto2.jpg';
import { useEffect } from 'react';

const Home = () => {
	useEffect(() => {
		mapboxgl.accessToken =
			'pk.eyJ1IjoicmFmYXU5NCIsImEiOiJja2dxd2pnbHYwOGU5MnJtZmFyczVxMTh3In0.-fMziZ-mHLmGMPSdWoze7w';
		const map = new mapboxgl.Map({
			container: 'map',
			style: 'mapbox://styles/mapbox/outdoors-v11',
			center: [21.075442420841455, 52.08469021137597],
			zoom: 12.8, // starting zoom
		});
		map.addControl(new mapboxgl.NavigationControl());
		map.scrollZoom.disable();

		const size = 100;

		// implementation of CustomLayerInterface to draw a pulsing dot icon on the map
		// see https://docs.mapbox.com/mapbox-gl-js/api/#customlayerinterface for more info
		const pulsingDot = {
			width: size,
			height: size,
			data: new Uint8Array(size * size * 4),

			// get rendering context for the map canvas when layer is added to the map
			onAdd: function () {
				const canvas = document.createElement('canvas');
				canvas.width = this.width;
				canvas.height = this.height;
				// @ts-ignore
				this.context = canvas.getContext('2d');
			},

			// called once before every frame where the icon will be used
			render: function () {
				const duration = 1000;
				const t = (performance.now() % duration) / duration;

				const radius = (size / 2) * 0.3;
				const outerRadius = (size / 2) * 0.7 * t + radius;
				// @ts-ignore
				const context = this.context;

				// draw outer circle
				context.clearRect(0, 0, this.width, this.height);
				context.beginPath();
				context.arc(
					this.width / 2,
					this.height / 2,
					outerRadius,
					0,
					Math.PI * 2
				);
				context.fillStyle = 'rgba(1, 58, 211,' + (1 - t) + ')';
				context.fill();

				// draw inner circle
				context.beginPath();
				context.arc(
					this.width / 2,
					this.height / 2,
					radius,
					0,
					Math.PI * 2
				);
				context.fillStyle = 'rgb(1,58,211)';
				context.strokeStyle = 'white';
				context.lineWidth = 2 + 4 * (1 - t);
				context.fill();
				context.stroke();

				// update this image's data with data from the canvas
				this.data = context.getImageData(
					0,
					0,
					this.width,
					this.height
				).data;

				// continuously repaint the map, resulting in the smooth animation of the dot
				map.triggerRepaint();

				// return `true` to let the map know that the image was updated
				return true;
			},
		};

		map.on('load', function () {
			map.addImage('pulsing-dot', pulsingDot, { pixelRatio: 2 });

			map.addSource('points', {
				type: 'geojson',
				data: {
					type: 'FeatureCollection',
					features: [
						{
							properties: {},
							type: 'Feature',
							geometry: {
								type: 'Point',
								coordinates: [
									21.075442420841455, 52.08469021137597,
								],
							},
						},
					],
				},
			});
			map.addLayer({
				id: 'points',
				type: 'symbol',
				source: 'points',
				layout: {
					'icon-image': 'pulsing-dot',
				},
			});
		});
	});
	useEffect(() => {
		mapboxgl.accessToken =
			'pk.eyJ1IjoicmFmYXU5NCIsImEiOiJja2dxd2pnbHYwOGU5MnJtZmFyczVxMTh3In0.-fMziZ-mHLmGMPSdWoze7w';
		const map = new mapboxgl.Map({
			container: 'map2',
			style: 'mapbox://styles/mapbox/outdoors-v11',
			center: [21.019757746044434, 52.10117970219639],
			zoom: 12.5, // starting zoom
		});
		map.addControl(new mapboxgl.NavigationControl());
		map.scrollZoom.disable();

		const size = 100;

		// implementation of CustomLayerInterface to draw a pulsing dot icon on the map
		// see https://docs.mapbox.com/mapbox-gl-js/api/#customlayerinterface for more info
		const pulsingDot = {
			width: size,
			height: size,
			data: new Uint8Array(size * size * 4),

			// get rendering context for the map canvas when layer is added to the map
			onAdd: function () {
				const canvas = document.createElement('canvas');
				canvas.width = this.width;
				canvas.height = this.height;
				// @ts-ignore
				this.context = canvas.getContext('2d');
			},

			// called once before every frame where the icon will be used
			render: function () {
				const duration = 1000;
				const t = (performance.now() % duration) / duration;

				const radius = (size / 2) * 0.3;
				const outerRadius = (size / 2) * 0.7 * t + radius;
				// @ts-ignore
				const context = this.context;

				// draw outer circle
				context.clearRect(0, 0, this.width, this.height);
				context.beginPath();
				context.arc(
					this.width / 2,
					this.height / 2,
					outerRadius,
					0,
					Math.PI * 2
				);
				context.fillStyle = 'rgba(1, 58, 211,' + (1 - t) + ')';
				context.fill();

				// draw inner circle
				context.beginPath();
				context.arc(
					this.width / 2,
					this.height / 2,
					radius,
					0,
					Math.PI * 2
				);
				context.fillStyle = 'rgb(1,58,211)';
				context.strokeStyle = 'white';
				context.lineWidth = 2 + 4 * (1 - t);
				context.fill();
				context.stroke();

				// update this image's data with data from the canvas
				this.data = context.getImageData(
					0,
					0,
					this.width,
					this.height
				).data;

				// continuously repaint the map, resulting in the smooth animation of the dot
				map.triggerRepaint();

				// return `true` to let the map know that the image was updated
				return true;
			},
		};

		map.on('load', function () {
			map.addImage('pulsing-dot', pulsingDot, { pixelRatio: 2 });

			map.addSource('points', {
				type: 'geojson',
				data: {
					type: 'FeatureCollection',
					features: [
						{
							properties: {},
							type: 'Feature',
							geometry: {
								type: 'Point',
								coordinates: [
									21.019757746044434, 52.10117970219639,
								],
							},
						},
					],
				},
			});
			map.addLayer({
				id: 'points',
				type: 'symbol',
				source: 'points',
				layout: {
					'icon-image': 'pulsing-dot',
				},
			});
		});
	});

	const common = { alt: 'Art Direction Example', sizes: '100vw' };
	const {
		props: { srcSet: desktop },
	} = getImageProps({
		...common,
		quality: 80,
		src: laundryBg,
	});
	const {
		props: { srcSet: mobile, ...rest },
	} = getImageProps({
		...common,
		quality: 70,
		src: laundryBgSmall,
	});

	return (
		<>
			<header id="home" className="app-header isolate">
				<Image
					alt="bg"
					src={headerBg}
					className="object-cover object-right lg:object-bottom"
					placeholder="blur"
					quality={100}
					fill
					sizes="100vw"
					style={{
						objectFit: 'cover', // cover, contain, none
					}}
					priority
				/>
				<div className="container relative flex-grow px-2 py-24 text-4xl text-white md:px-4 md:text-5xl">
					<div className="relative z-[2]">
						<h1 className="font-black">ECO PRALNIA NR 1</h1>
						<h3 className="max-w-4xl mt-8 font-semibold leading-none">
							ELIMINUJEMY{' '}
							<Image
								src="/assets/splash.svg"
								alt="Splash icon"
								height="55"
								width="55"
								className="hidden h-12 -mt-6 xl:inline-block"
							/>
							<br className="hidden xl:inline" />
							TOKSYCZNĄ CHEMIĘ Z<br />
							PRANIA
						</h3>
						<p className="flex flex-col items-center mt-8 text-4xl font-thin md:flex-row">
							<PhoneIcon className="w-12 h-12 mb-4 mr-0 md:mr-6 md:mb-0" />
							<a href="tel:+48690003993">690 003 993</a>
							<span className="text-white ml-6 font-semibold">
								Konstancin
							</span>
						</p>
						<p className="flex flex-col items-center mt-4 text-4xl font-thin md:flex-row">
							<PhoneIcon className="w-12 h-12 mb-4 mr-0 md:mr-6 md:mb-0" />
							<a href="tel:+48690003993">690 610 260</a>
							<span className="text-white ml-6 font-semibold">
								SanPark Piaseczno
							</span>
						</p>
					</div>

					<div
						className="absolute h-full w-full top-0 left-0 right-0 z-[1] transform-gpu backdrop-blur-[2px] block sm:hidden"
						aria-hidden="true"
					>
						<div className="w-full h-full opacity-75 bg-linear-to-r from-blue-900 to-blue-500"></div>
					</div>
				</div>
			</header>

			<section
				id="about"
				className="relative flex items-center min-h-screen"
			>
				<picture className="absolute inset-0 object-cover w-full h-full">
					<source media="(min-width: 768px)" srcSet={desktop} />
					<source media="(min-width: 100px)" srcSet={mobile} />
					<Image
						alt="bg"
						src={laundryBg}
						className="object-cover object-right lg:object-bottom"
						placeholder="blur"
						quality={100}
						fill
						sizes="100vw"
						style={{
							objectFit: 'cover', // cover, contain, none
						}}
					/>
				</picture>

				<div className="container relative flex flex-col items-center justify-center flex-grow px-2 py-24 md:px-4 md:items-end md:justify-end">
					<div className="flex flex-col gap-8">
						<div className="order-2 max-w-xl md:order-1">
							<h3 className="mb-4 text-center">
								ECO PRALNIA
								<br />
								FAST & CLEAN W WARSZAWIE
							</h3>
							<p className="text-justify">
								Pralnia Fast & Clean oferuje szybkie i
								profesjonalne usługi pralnicze, dbając
								jednocześnie o ochronę środowiska naturalnego.
								Każde ubranie trafia do klienta nieskazitelnie
								czyste, odzyskując swój elegancki wygląd.
							</p>
							<p className="text-justify">
								W trosce o zdrowie klientów i pracowników
								całkowicie wyeliminowaliśmy toksyczne środki
								chemiczne, wprowadzając nowoczesny system Eco
								Lagoon – innowacyjne i ekologiczne rozwiązanie w
								branży pralniczej. Dzięki temu zapewniamy
								ochronę zdrowia naszych klientów i troskę o
								środowisko.
							</p>
							<p className="text-justify">
								Korzystając z usług pralni Fast & Clean, możesz
								liczyć na idealną czystość i elegancję ubrań w
								krótkim czasie, a wszystko to z poszanowaniem
								natury.
							</p>
						</div>

						<div className="flex items-center justify-center order-1 max-w-xl md:order-2">
							<div className="shrink-0  rounded-lg overflow-hidden shadow-lg aspect-1 h-[280px] w-[280px]">
								<Image
									src="/assets/foto1.jpg"
									height={280}
									width={280}
									alt="Photo 1"
								/>
							</div>
						</div>
					</div>
				</div>
			</section>

			<div className="flex items-center justify-center gap-24 px-24 pt-24">
				<div className="max-h-[215px] max-w-[913px] block">
					<Image
						src="/assets/woda.png"
						width={913}
						height={215}
						alt="Woda"
					/>
				</div>
			</div>

			<section id="tech" className="flex items-center">
				<div className="container relative flex flex-col-reverse items-center justify-center flex-grow px-2 py-24 md:px-4 lg:flex-row-reverse gap-y-8">
					<div className="block w-full mt-16 xl:w-1/3 md:mt-0">
						<div className="rounded-lg overflow-hidden shadow-lg mx-auto lg:ml-10 relative aspect-[5/3] h-auto md:max-w-[501px] md:h-[338px]">
							<Image
								alt="Photo 2"
								src={photo2}
								width={501}
								height={338}
							/>
						</div>
					</div>
					<div className="w-full mr-0 text-center xl:max-w-xl xl:mr-24">
						<h3 className="mb-4 leading-relaxed tracking-widest text-blue-600">
							NOWOCZESNA TECHNOLOGIA
						</h3>
						<p className="mb-4 text-justify">
							Dzięki innowacyjnej technologii Eco Lagoon
							zapewniamy ubraniom nieskazitelną czystość i świeży,
							naturalny zapach – bez potrzeby stosowania
							chemicznych środków czyszczących. System ten
							wykorzystuje wodę, eliminując toksyczne
							rozpuszczalniki, a jednocześnie skutecznie czyści
							nawet najdelikatniejsze tkaniny, takie jak wełna,
							kaszmir czy jedwab.
						</p>
						<p className="mb-4 text-justify">
							Dzięki temu odzież zachowuje trwałość i elegancki
							wygląd, a Ty masz pewność, że dbasz o swoje zdrowie
							oraz środowisko.
						</p>
						<p className="mb-4 text-justify">
							Technologia Eco Lagoon pozwala cieszyć się doskonałą
							jakością prania, chroniąc jednocześnie Twoje
							otoczenie. Łączymy skuteczność z ekologią, bo
							wierzymy, że czystość może iść w parze z troską o
							planetę.
						</p>
					</div>
				</div>
			</section>

			<section id="laundry" className="flex items-center overflow-hidden">
				<div className="container flex flex-col flex-grow px-2 py-12 lg:py-24 md:px-4">
					<h2>Pranie na zawołanie</h2>

					<ul className="icons">
						<li>
							<Image
								height="60"
								width="60"
								src="/assets/phone.svg"
								alt="Phone icon"
							/>
							<h6>Dzwonisz do nas</h6>
						</li>
						<li>
							<Image
								height="60"
								width="60"
								src="/assets/car.svg"
								alt="Car icon"
							/>
							<h6>Odbieramy twoje pranie</h6>
						</li>
						<li>
							<Image
								height="60"
								width="60"
								src="/assets/machine.svg"
								alt="Machine icon"
							/>
							<h6>Wykonujemy zleconą usługę</h6>
						</li>
						<li>
							<Image
								height="60"
								width="60"
								src="/assets/folded.svg"
								alt="Folded icon"
							/>
							<h6>Przywozimy czyste, pachnące pranie</h6>
						</li>
					</ul>

					<div className="flex flex-col items-center justify-center mt-24 xl:mt-0">
						<div className="grid grid-cols-1 xl:grid-cols-2 gap-4 xl:gap-12 gap-y-24">
							<div className="text-center">
								<h2 className="!mb-2">Konstancin</h2>
								<p className="!mt-0 !mb-0 text-gray-500 !font-normal">
									ul. Kazimierza Pułaskiego 2/6
								</p>
								<p className="!mt-0 !mb-0 text-gray-500 !font-normal">
									05-510, Konstancin-Jeziorna
								</p>
								<p className="flex flex-col items-center justify-center text-2xl font-light md:flex-row md:text-4xl">
									<PhoneIcon className="size-8 xl:size-12 mr-0 text-blue-600 md:mr-2 md:mb-0" />
									<a href="tel:+48690003993">690 003 993</a>
								</p>
								<p className="flex flex-col items-center justify-center text-2xl font-light md:flex-row md:text-4xl">
									<span className="mr-0 font-bold text-center text-blue-600 md:mr-2 md:mb-0">
										@
									</span>
									<a
										href="mailto:ecopralniafast@gmail.com"
										className="text-center break-all"
									>
										ecopralniafast@gmail.com
									</a>
								</p>
							</div>

							<div className="text-center">
								<h2 className="!mb-2 relative flex items-center justify-center">
									SanPark Piaseczno
								</h2>
								<p className="!mt-0 !mb-0 text-gray-500 !font-normal">
									ul. Puławska 56E/09
								</p>
								<p className="!mt-0 !mb-0 text-gray-500 !font-normal">
									05-500, Mysiadło
								</p>
								<p className="flex flex-col items-center justify-center text-2xl font-light md:flex-row md:text-4xl">
									<PhoneIcon className="size-8 xl:size-12 mr-0 text-blue-600 md:mr-2 md:mb-0" />
									<a href="tel:690610260">690 610 260</a>
								</p>
								<p className="flex flex-col items-center justify-center text-2xl font-light md:flex-row md:text-4xl">
									<span className="mr-0 font-bold text-center text-blue-600 md:mr-2 md:mb-0">
										@
									</span>
									<a
										href="mailto:ecopralniafast@gmail.com"
										className="text-center break-all"
									>
										ecopralniafast@gmail.com
									</a>
								</p>
							</div>
						</div>

						<Link passHref href="/cennik" legacyBehavior>
							<a href="" className="mt-16 button">
								Cennik
							</a>
						</Link>
					</div>

					<div className="relative flex flex-wrap items-center justify-center gap-24 mt-32">
						<div>
							<div className="flex flex-col items-center justify-center">
								<h2 className="mb-4 uppercase">Wykonujemy:</h2>
								<ul className="font-bold text-gray-700 list-disc list-outside">
									<li>Dezynfekcje odzieży</li>
									<li>Magiel i pranie z maglem</li>
								</ul>
							</div>
							<div className="flex flex-col items-center justify-center mt-12">
								<h2 className="mb-4 uppercase">Pierzemy:</h2>
								<ul className="font-bold text-gray-700 list-disc list-outside">
									<li>Dywany</li>
									<li>Suknie ślubne</li>
									<li>Koce</li>
									<li>Narzuty</li>
									<li>Pokrowce na materace</li>
								</ul>
							</div>
						</div>

						<div className="max-h-[537px] max-w-[345px] block">
							<Image
								src="/assets/lagoon@2x.png"
								width={568}
								height={813}
								sizes="568px"
								alt="Woda"
							/>
						</div>
					</div>
				</div>
			</section>

			<div className="flex items-center justify-center gap-24 px-24">
				<div className="max-h-[90px] max-w-[400px] block">
					<Image
						src="/assets/electrolux_professional.png"
						width={790}
						height={177}
						alt="Electrolux Professional"
					/>
				</div>
			</div>

			<section id="contact" className="flex flex-col items-center">
				<div className="container flex flex-col flex-grow pt-24 pb-0">
					<h2 className="mb-10">LOKALIZACJA PRALNI</h2>
				</div>

				<div className="grid w-full grid-cols-1 lg:grid-cols-2 grow">
					<div>
						<div id="map">
							<div className="details">
								<p className="!text-lg">MPark</p>
								<p>ul. Kazimierza Pułaskiego 2/6</p>
								<p>05-510, Konstancin-Jeziorna</p>
								<p>pon. - pt. : 09:00 - 19:00</p>
								<p>sob. : 09:00 - 15:00</p>
								<p>ndz. : nieczynne</p>
								<p>
									tel.:{' '}
									<a href="tel:690003993">690 003 993</a>
								</p>
								<p>
									email:&nbsp;
									<a href="mailto:ecopralniafast@gmail.com">
										ecopralniafast@gmail.com
									</a>
								</p>
							</div>
						</div>
					</div>
					<div>
						<div id="map2">
							<div className="details">
								<p className="!text-lg relative">
									SanPark Piaseczno
								</p>
								<p>ul. Puławska 56E/09</p>
								<p>05-500, Mysiadło</p>
								<p>pon. - pt. : 09:00 - 20:00</p>
								<p>sob. : 09:00 - 18:00</p>
								<p>ndz. : czynne w handlowe</p>
								<p>
									tel.:{' '}
									<a href="tel:690610260">690 610 260</a>
								</p>
								<p>
									email:&nbsp;
									<a href="mailto:ecopralniafast@gmail.com">
										ecopralniafast@gmail.com
									</a>
								</p>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default Home;
